import * as React from "react"
import compose from "recompose/compose"
import injectSheet from "react-jss"
import { withi18n } from "@/helpers/hoc/withi18n"
import { withDateRange } from "@/helpers/hoc/withDateRange"
import { Text, Tooltip } from "@xingternal/360-components"

const i18n = {
  compare: "360_RECRUITER_INSIGHTS_OVERVIEW_COMPARE_PREVIOUS_PERIOD",
  comingSoon: "360_RECRUITER_INSIGHTS_FEATURE_COMING_SOON",
}

const styles = {
  container: { composes: "mt8" },
  checkbox: { composes: "inline-block ml0 mr8 mt0 mb0 fz18" },
  checkboxText: {
    composes: "inline-block",
    opacity: ({ comparisonDisabled }) => comparisonDisabled && 0.4,
  },
}

const enhance = compose(
  withi18n(i18n),
  injectSheet(styles),
)

const ComparisonText = enhance(({ classes, comparisonDisabled, compare }) => (
  <React.Fragment>
    <Text className={classes.checkboxText}>{compare}</Text>
  </React.Fragment>
))

const ComparisonController = ({
  classes,
  compare,
  toggleCompare,
  comparisonDisabled,
  comingSoon,
}) => (
  <div className={classes.container}>
    <label htmlFor="compareCheckbox">
      <input
        id="compareCheckbox"
        type="checkbox"
        disabled={comparisonDisabled}
        checked={compare && !comparisonDisabled ? "checked" : ""}
        className={classes.checkbox}
        onChange={toggleCompare}
      />
      {comparisonDisabled ? (
        <Tooltip position="bottom" text={comingSoon}>
          <ComparisonText comparisonDisabled={comparisonDisabled} />
        </Tooltip>
      ) : (
        <ComparisonText comparisonDisabled={comparisonDisabled} />
      )}
    </label>
  </div>
)

export default enhance(withDateRange(ComparisonController))
